import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './BaseSearchDropdown.scss';
import SearchTextField from './SearchTextField';
import FormField from './form/FormField';

export default class BaseSearchDropdown extends PureComponent {
    static propTypes = {
        onChange: PropTypes.func,
        error: PropTypes.string,
        label: PropTypes.string,
        dropdownList: PropTypes.array,
        dropdownListProcessing: PropTypes.bool,
        onSearch: PropTypes.func.isRequired,
        hardSet: PropTypes.bool,
        autoClear: PropTypes.bool,
        className: PropTypes.string,
        disabled: PropTypes.bool,
        light: PropTypes.bool,
        totalCount: PropTypes.number,
        loadOnScroll: PropTypes.func
    };

    static defaultProps = {
        hardSet: true,
        onChange: null,
        error: null,
        label: '',
        dropdownList: [],
        totalCount: 0,
        dropdownListProcessing: false,
        className: '',
        disabled: false,
        light: false,
    };

    state = {
        value: null,
    };

    constructor(props) {
        super(props);

        this.state = {
            value: props.value,
            dropdownList: props.dropdownList,
        };
    }

    componentWillReceiveProps(next) {
        const {needToMerge, dropdownList} = this.state;
        const updatedState = {
            dropdownList: [
                ...(needToMerge ? dropdownList : []),
                ...next.dropdownList,
            ]
        };
        if (this.props.value && !next.value) {
            updatedState.value = null;
        }
        this.setState(updatedState);
    }

    handleChoose = (value) => {
        const {onChange} = this.props;
        this.setState({value}, onChange.bind(null, {target: {value}}));
    };

    onSearch = (value) => {
        this.setState({
            needToMerge: false,
            dropdownList: []
        }, this.props.onSearch.bind(this, value));
    }

    loadOnScroll = (value, count) => {
        this.setState({
            needToMerge: true
        }, this.props.loadOnScroll.bind(this, value, count));
    }

    render() {
        const {value, dropdownList} = this.state;
        const {
            label,
            error,
            light,
            dropdownListProcessing,
            onChange,
            hardSet,
            autoClear,
            loadOnScroll,
            onSearch,
            className,
            ...rest
        } = this.props;

        const baseFormatter = (value) => value;
        const formatter = this.formatter || baseFormatter;

        return (
            <FormField label={label} error={error} className={className}>
                {value && !_.isEmpty(value) && hardSet
                    ? <div className={classnames(styles.container, {[styles.white]: light})}>
                        {formatter(value)}
                        <div className={styles.clearButton} onClick={this.handleChoose.bind(this, null)} />
                    </div>
                    : <SearchTextField
                        loadOnScroll={loadOnScroll && this.loadOnScroll.bind(this)}
                        onSearch={this.onSearch.bind(this)}
                        searchResult={dropdownList}
                        searchResultProcessing={dropdownListProcessing}
                        formatter={formatter}
                        onChoose={this.handleChoose}
                        onChange={onChange}
                        autoClear={autoClear}
                        label={label}
                        error={error}
                        light={light}
                        hardSet={hardSet}
                        value={value}
                        needFullResult
                        {...rest}
                    />
                }
            </FormField>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/controls/BaseSearchDropdown.js